export const PaymentUpdateAction = {
    SelectPaymentUpdateData: "SELECTPAYMENTUPDATEDATA",
    UnSelectPaymentUpdateData:"UNSELECTPAYMENTUPDATEDATA",
}

const paymentUpdateData = null;

const PaymentUpdateReducer = (payUpdtData = paymentUpdateData, actions) => {

    switch (actions.type) {
        case PaymentUpdateAction.SelectPaymentUpdateData:
            payUpdtData = [];
            payUpdtData = actions.payload;
            return payUpdtData;
        case PaymentUpdateAction.UnSelectPaymentUpdateData:
            payUpdtData = [];
            //payUpdtData = actions.payload;
            return payUpdtData;
        default:
            return payUpdtData;
    }
}
export default PaymentUpdateReducer;